import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/vip.png'


const _hoisted_1 = { class: "btn-base" }
const _hoisted_2 = { key: 0 }

import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openVIP } from "@/components/Dialogues/useData/useDialogues";
import { isCompactMode } from "@/data/pubilc";
import { openLoginDialog } from "@/components/Dialogues/useData/login";

export default /*@__PURE__*/_defineComponent({
  __name: 'UserVipInfoBtn',
  setup(__props) {

const { isLogin, vipDisplay } = storeToRefs(publicStore());

return (_ctx: any,_cache: any) => {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isLogin))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["vip", {
        'vip-moile': _unref(isCompactMode),
      }]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openVIP) && _unref(openVIP)(...args)))
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("img", {
            class: "vip-icon",
            src: _imports_0,
            alt: "",
            srcset: ""
          }, null, -1)),
          (!_unref(isCompactMode))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(vipDisplay)), 1))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "login",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(openLoginDialog) && _unref(openLoginDialog)(...args)))
        }, [
          _createVNode(_component_el_icon, { size: 26 }, {
            default: _withCtx(() => [
              _createVNode(_component_UserFilled)
            ]),
            _: 1
          })
        ]))
  ]))
}
}

})